import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import StorefrontLayout from "../components/storefront/Layout";
import Breadcrumbs, { breadcrumbJsonLd } from "../components/storefront/Breadcrumbs";
import { api } from "../lib/api";
import { useSeo } from "../lib/seo";

const groupOf = (b) => b.brand_group || (b.is_exotic ? "exotic_luxury" : "other");

export default function Brands() {
  const [brands, setBrands] = useState([]);
  useEffect(() => {
    api.get("/vehicles/makes").then(({ data }) => setBrands(data.makes || []));
  }, []);

  const exotic = brands.filter((b) => groupOf(b) === "exotic_luxury");
  const ev = brands.filter((b) => groupOf(b) === "ev_specialty");
  const other = brands.filter((b) => groupOf(b) === "other");

  const crumbs = [{ label: "Home", to: "/" }, { label: "Brands", to: "/brands" }];
  useSeo({
    title: "Auto Glass by Brand — Exotic, EV & More | Lecis Auto Glass",
    description: "Shop side mirrors, windshields, backglass and sunroof glass by brand — exotic & luxury marques, EV specialty brands, and other vehicle brands. Shipped nationwide.",
    canonicalPath: "/brands",
    jsonLd: { breadcrumb: breadcrumbJsonLd(crumbs) },
  });

  return (
    <StorefrontLayout>
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16" data-testid="brands-page">
        <Breadcrumbs items={crumbs} />
        <div className="mb-12">
          <div className="text-[10px] uppercase tracking-[0.3em] text-red-500 font-bold mb-3">All brands</div>
          <h1 className="font-display text-4xl md:text-6xl tracking-tighter font-medium">Browse by brand</h1>
        </div>

        <BrandSection title="Exotic & Luxury" brands={exotic} accent="red" testid="brand-group-exotic_luxury" />
        <BrandSection title="EV Specialty" brands={ev} accent="red" testid="brand-group-ev_specialty" />
        <BrandSection title="Other Vehicle Brands" brands={other} accent="white" testid="brand-group-other" />
      </div>
    </StorefrontLayout>
  );
}

function BrandSection({ title, brands, accent, testid }) {
  if (!brands || brands.length === 0) return null;
  const hover = accent === "red" ? "hover:border-red-500/50 group-hover:text-red-500" : "hover:border-white/30 group-hover:text-white";
  const [borderHover, textHover] = hover.split(" ");
  return (
    <div className="mb-16" data-testid={testid}>
      <h2 className="font-display text-xl tracking-tight mb-6 text-zinc-400">{title}</h2>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {brands.map((b) => (
          <Link
            key={b.id}
            to={`/${b.slug}`}
            data-testid={`brands-link-${b.slug}`}
            className={`group bg-[#0d0d0d] border border-white/5 ${borderHover} rounded-md p-8 transition`}
          >
            <div className={`font-display text-xl tracking-tight ${textHover} transition`}>{b.name}</div>
            <div className="text-[10px] uppercase tracking-[0.25em] text-zinc-500 mt-2">View Parts →</div>
          </Link>
        ))}
      </div>
    </div>
  );
}
